import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./ModalAttendanceComment.module.sass";
import Modal from "../Modal";
import Icon from "../Icon";

const ModalAttendanceComment = ({ visible, onClose, attendance, onSave }) => {
    const [comment, setComment] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    // Charger le commentaire existant à l'ouverture
    useEffect(() => {
        if (visible && attendance) {
            setComment(attendance.comments || "");
        }
    }, [visible, attendance]);

    const handleSave = async () => {
        if (isSaving) return;
        
        setIsSaving(true);
        try {
            await onSave(comment);
        } finally {
            setIsSaving(false);
        }
    };

    const handleClear = () => {
        setComment("");
    };

    // Récupérer les informations du participant
    const participant = attendance?.expand?.participant_id;
    const participantName = participant 
        ? `${participant.first_name} ${participant.last_name}` 
        : 'Participant inconnu';

    return (
        <Modal visible={visible} onClose={onClose} outerClassName={styles.outer}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.icon}>
                        <Icon name="message" size="24" />
                    </div>
                    <div className={styles.title}>Commentaire</div>
                </div>

                <div className={styles.info}>
                    <span className={styles.label}>Participant :</span>
                    <span className={styles.value}>{participantName}</span>
                </div>

                <div className={styles.form}>
                    <div className={styles.field}>
                        <label className={styles.fieldLabel}>Commentaire</label>
                        <textarea
                            className={styles.textarea}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Ajouter un commentaire sur cette présence..."
                            rows={5}
                        />
                    </div>
                </div>

                <div className={styles.actions}>
                    <button 
                        className={cn("button-stroke", styles.button)}
                        onClick={handleClear}
                        disabled={!comment || isSaving}
                    >
                        Effacer
                    </button>
                    <button 
                        className={cn("button", styles.button)}
                        onClick={handleSave}
                        disabled={isSaving}
                    >
                        {isSaving ? "Enregistrement..." : "Enregistrer"}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalAttendanceComment;
